<h2 mat-dialog-title class="pb-[0.5em]! text-xl! sm:text-2xl! px-4! sm:px-6!">
    {{ config().title }}
</h2>
<mat-divider />
<mat-dialog-content
    class="pt-4 px-4! sm:px-6!"
    [ngClass]="{ 'pointer-events-none opacity-50': isSubmitting() }">
    <ng-content />
</mat-dialog-content>
<mat-divider />
<mat-dialog-actions align="end" class="px-4! sm:px-6! py-4! gap-2">
    <button
        mat-stroked-button
        type="button"
        color="warn"
        [disabled]="isCancelDisabled()"
        (click)="onCancelClicked()">
        @if (config().cancelIcon) {
            <mat-icon>{{ config().cancelIcon }}</mat-icon>
        }
        {{ cancelButtonLabel() }}
    </button>
    @if (showConfirmButton()) {
        <apcam-tooltip-custom
            [customMatTooltip]="confirmTooltipText()"
            [customMatTooltipDisabled]="!showConfirmTooltip()">
            <button
                mat-flat-button
                type="button"
                color="primary"
                [attr.aria-busy]="confirmButtonAriaBusy()"
                [attr.aria-label]="confirmButtonAriaLabel()"
                [disabled]="isConfirmDisabled()"
                (click)="onConfirmClicked()">
                @if (isSubmitting()) {
                    <mat-icon><apcam-loading-spinner size="xs" /></mat-icon>
                } @else if (config().confirmIcon) {
                    <mat-icon>{{ config().confirmIcon }}</mat-icon>
                }
                {{ confirmButtonLabel() }}
            </button>
        </apcam-tooltip-custom>
    }
</mat-dialog-actions>
